import React, { useEffect, useRef } from "react"
import type { VariantType } from "@shared/graphql.types"
import { ShadeSelectorButton } from "./ShadeSelectorButton"
import { ShadeSelectorList } from "./ShadeSelectorList"
import { shadeSelector } from "./ShadeSelector.css"

export type Props = {
  variant: VariantType
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  isModalOpen: boolean
}

export const ShadeSelector: React.FC<Props> = ({
  variant,
  setIsModalOpen,
  isModalOpen,
}) => {
  const modalButtonRef = useRef<HTMLDivElement>(null)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  useEffect(() => {
    document.body.style.overflow = "auto"
    if (isModalOpen === true) {
      document.body.style.overflow = "hidden"
      if (modalButtonRef.current) {
        modalButtonRef.current.focus()
      }
    }
  }, [isModalOpen])

  return (
    <div className={shadeSelector} data-testid="shade-selector">
      <ShadeSelectorButton
        variant={variant}
        onOpenModal={handleOpenModal}
        isModalOpen={isModalOpen}
      />

      <ShadeSelectorList variant={variant} />
    </div>
  )
}
